export default __webpack_public_path__ + "static/media/icon-workshop.183435b6.svg";